import React, {useState, useEffect}  from 'react';
import { useLocation,useHistory } from 'react-router-dom';
import { StyledHeader } from './StyledHeader';
import MenuIndustries from '../MenuIndustries';
import MobileMenuWrap from '../MobileMenuWrap';

import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";

const Header = () => {
  const [isOpenIndustries, setIsOpenIndustries] =  useState(false);
  const [isOpenMenuMobile, setIsOpenMenuMobile] =  useState(false);
  const [areMenusOpen, setAreMenusOpen] = useState(false);
  const [isWhiteMenu, setIsWhiteMenu] =  useState(false);
  const [showSticky, setShowSticky] = useState(false);
  const [smallContact, setSmallContact] =  useState(false);

  const location = useLocation();
  var lastScroll = 0;
  const dispatch = useDispatch();
  let history = useHistory();

  const openIndustriesMenuDesk = () => {
    setIsOpenIndustries(!isOpenIndustries)
  }

  const backMenu = () => {
    if(isOpenIndustries) setIsOpenIndustries(false);
  }
  
  useEffect(() => {
    var isWhitePage = location.pathname === '/' || location.pathname === '/home' || location.pathname.includes('/industries/') ||  location.pathname.includes('/products/index') ||  location.pathname.includes('/shelfzone') ||  location.pathname.includes('/virtual-showroom')
    setIsWhiteMenu(isWhitePage);
  }, [location]);

  // toggle menus desktop
  useEffect(() => {
    var isWhitePage = location.pathname === '/' || location.pathname === '/home' || location.pathname.includes('/industries/') ||  location.pathname.includes('/products/index') ||  location.pathname.includes('/shelfzone') ||  location.pathname.includes('/virtual-showroom')

    if(isWhiteMenu && (isOpenIndustries )){
      setIsWhiteMenu(false);
    }else if(isWhitePage && (!isOpenIndustries )){
      setIsWhiteMenu(true);
    }

    setAreMenusOpen(isOpenIndustries )

  }, [isOpenIndustries]);

  // toggle menu mobile
  useEffect(() => {
    var isWhitePage = location.pathname === '/' || location.pathname === '/home' || location.pathname.includes('/industries/') ||  location.pathname.includes('/products/index') ||  location.pathname.includes('/shelfzone') ||  location.pathname.includes('/virtual-showroom')
    const body = document.querySelector('body');
    body.style.overflow = isOpenMenuMobile ? 'hidden' : 'scroll';

    if(isWhiteMenu && (isOpenMenuMobile)){
      setIsWhiteMenu(false);
    }else if(isWhitePage && (!isOpenMenuMobile)){
      setIsWhiteMenu(true);
    }

  }, [isOpenMenuMobile]);

  const changeMenuSelection = ()  => {
    var currentActive = document.querySelectorAll('.active');

    for(var i = 0; i < currentActive.length; i++){
      currentActive[i].classList.remove('active');
    }
    
    if(history.location.pathname.includes('industries')){
      var industriesRoute = document.querySelectorAll('.industries-route');
      
      for(var x = 0; x < industriesRoute.length; x++){
        industriesRoute[x].classList.add('active');
      }
    }

    if(history.location.pathname.includes('3d-e-commerce') ){
       var ecommerceRoute = document.querySelectorAll('.commerce-route');
      
      for(var x = 0; x < ecommerceRoute.length; x++){
        ecommerceRoute[x].classList.add('active');
      }
    }

    if(history.location.pathname.includes('virtual-showroom') ){
       var virtualShowRoute = document.querySelectorAll('.virtual-route');
      
      for(var x = 0; x < virtualShowRoute.length; x++){
        virtualShowRoute[x].classList.add('active');
      }
    }

    if(history.location.pathname.includes('full-reality')){
      var fullRealityRoute = document.querySelectorAll('.full-reality-route');
      for(var x = 0; x < fullRealityRoute.length; x++){
        fullRealityRoute[x].classList.add('active');
      }
    }

    if(history.location.pathname.includes('shelfzone')){
      var fullRealityRoute = document.querySelectorAll('.shelfzone-route');
      for(var x = 0; x < fullRealityRoute.length; x++){
        fullRealityRoute[x].classList.add('active');
      }
    }

    if(history.location.pathname.includes('news')){
      var fullRealityRoute = document.querySelectorAll('.news-route');
      for(var x = 0; x < fullRealityRoute.length; x++){
        fullRealityRoute[x].classList.add('active');
      }
    }

  }
  useEffect(() =>{

    changeMenuSelection();

    document.body.addEventListener('scroll', () =>{
      
      var st = document.body.pageYOffset || document.body.scrollTop; 
      
      if (st > lastScroll){
        setShowSticky(false)
        setSmallContact(true)
      } else {
        setShowSticky(true)
        setSmallContact(false)
        if(st <= 60){
          setShowSticky(false)
          setSmallContact(false)
        }
      }
      lastScroll = st <= 0 ? 0 : st;
    })
  }, [history.location.pathname])

  useEffect(() =>{
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [isOpenIndustries, areMenusOpen])

  const handleResize = () => {
    console.log( areMenusOpen )
    if( window.innerWidth < 1024 && !isOpenMenuMobile){
       setAreMenusOpen(false)
       
    }else if(window.innerWidth >= 1024 && ( isOpenIndustries )) {
      setAreMenusOpen(true)
    }
  }

  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      dispatch(setLoader(true))
      if(isOpenIndustries) setIsOpenIndustries(false);
      if(isOpenMenuMobile) setIsOpenMenuMobile(false);

      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
    
  }

  return (
    <React.Fragment>
      {
      
          <StyledHeader>
            <div className={`${isWhiteMenu ? 'white--menu' : ''} header--wrapper`}>
              <div className="header--logo-wrap">
                <div className={ (areMenusOpen) ? "back header--logo-row" : "header--logo-row"}>
                  <span onClick={() => handleCLick("/")} >
                    <img className="logo black-logo" src={require('../../assets/logo-black.png')} />
                    <img className="logo white-logo" src={require('../../assets/logo-white.png')}  />
                  </span>
                </div>
                <div className="header--logo-row" onClick={() => backMenu()}>
                  <img className="prev" src="/cta-arrow-prev-green.svg"  />
                </div>
              </div>
              {
                !location.pathname.includes('/3d-commerce-experience') &&
                <>
                <div className="header--main-list-wrap hide-tablet">
                  <p className="regular commerce-route" onClick={()=>handleCLick("/3d-e-commerce")}>3D e-commerce</p>
                  <p className="regular shelfzone-route" onClick={() => handleCLick("/shelfzone")}>
                    Shelfzone
                  </p>
                  <p className="regular virtual-route" onClick={()=>handleCLick("/virtual-showroom")}>Virtual Showroom</p>
                  <p className="regular industries-route" onClick={()=>openIndustriesMenuDesk()}>Industries</p>
                  <p className="regular full-reality-route" onClick={() => handleCLick("/full-reality")}>
                    Full Reality
                  </p>
                  <p className="regular news-route" onClick={() => handleCLick("/news")}>
                    News & Events
                  </p>
                  
                </div>
                
                <div className="header--last-col">
                 
                  <div className="hide-desktop menu--toggle-wrap" onClick={()=>setIsOpenMenuMobile(!isOpenMenuMobile)}>
                    <div id="menu--toggle" className={isOpenMenuMobile ? 'open' : ''}>
                      <span></span>
                      <span></span>
                      <span></span>
                      <div className="close">
                      </div>
                    </div>
                  </div>
                </div>
                </>
              }
              {
                ( location.pathname === '/3d-commerce-experience' || 
                  location.pathname === '/3d-commerce-experience/configurator' ||
                  location.pathname.includes('/3d-commerce-experience/item-') ) &&
                <>
                  <div className="back-to-3d" onClick={() => handleCLick(location.pathname === '/3d-commerce-experience' ? "/3d-e-commerce" : '/3d-commerce-experience')}>
                    <img src={require('../../assets/arrow-back-experience.svg')} />
                    <p className="regular" >
                      
                      <span className="hide-mobile hide-tablet">
                        { 
                          location.pathname === '/3d-commerce-experience' ? 
                          "3D e-commerce" : ""
                        }
                      </span>
                    </p>
                  </div>
                </>
              }
            
            </div>
            <div id="sticky--header" className={`${showSticky ? 'show' : ''} header--wrapper`}>
              <div className="header--logo-wrap">
                <div className={ (isOpenIndustries ) ? "back header--logo-row" : "header--logo-row"}>
                  <span onClick={() => handleCLick("/")} >
                    <img className="logo black-logo" src={require('../../assets/logo-black.png')} />
                    <img className="logo white-logo" src={require('../../assets/logo-white.png')}  />
                  </span>
                </div>
                <div className="header--logo-row" onClick={() => backMenu()}>
                  <img className="prev" src="/cta-arrow-prev-green.svg"  />
                </div>
              </div>
              {
                !location.pathname.includes('3d-commerce-experience') &&
              
              <>
                <div className="header--main-list-wrap hide-tablet">
                  <p className="regular commerce-route" onClick={()=>handleCLick("/3d-e-commerce")}>3D e-commerce</p>

                  <p className="regular shelfzone-route"  onClick={() => handleCLick("/shelfzone")}>
                    Shelfzone
                  </p>
                  <p className="regular virtual-route" onClick={()=>handleCLick("/virtual-showroom")}>Virtual Showroom</p>

                  <p className="regular industries-route" onClick={()=>openIndustriesMenuDesk()}>Industries</p>
                  <p className="regular full-reality-route"  onClick={() => handleCLick("/full-reality")}>
                    Full Reality
                  </p>
                  <p className="regular news-route"  onClick={() => handleCLick("/news")}>
                    News & Events
                  </p>
                </div>
                <div className="header--last-col">
                
                  <div className="hide-desktop menu--toggle-wrap" onClick={()=>setIsOpenMenuMobile(!isOpenMenuMobile)}>
                    <div id="menu--toggle" className={isOpenMenuMobile ? 'open' : ''}>
                      <span></span>
                      <span></span>
                      <span></span>
                      <div className="close">
                      </div>
                    </div>
                  </div>
                </div>
                </>
              }
              {
               (  location.pathname === '/3d-commerce-experience' || 
                  location.pathname === '/3d-commerce-experience/configurator' ||
                  location.pathname.includes('/3d-commerce-experience/item-') )&&
                <>
                  <div className="back-to-3d" onClick={() => handleCLick( location.pathname === '/3d-commerce-experience' ? "/3d-e-commerce" : '/3d-commerce-experience' )}>
                    <img src={require('../../assets/arrow-back-experience.svg')} />
                    <p className="regular" >
                      
                      <span className="hide-mobile hide-tablet">
                        { 
                          location.pathname === '/3d-commerce-experience' ? 
                          "3D e-commerce" : ""
                        }
                      </span>
                    </p>
                  </div>
                </>
              }
            </div>
            <div className={`${areMenusOpen ? 'show' :''} menu-desk--bg `}>
              <MenuIndustries toggle={isOpenIndustries} toggleFn={setIsOpenIndustries} onlyDesktop={true} />
             
            </div>
            
            <MobileMenuWrap toggle={isOpenMenuMobile} toggleFn={setIsOpenMenuMobile} handleLoad={handleCLick}>
              
            </MobileMenuWrap>
            <div 
                className={ `rounded--cta fixed-cta ${smallContact ? 'small-cta' : ''}`} 
                
                onClick={() => handleCLick("/contact-us")}
                style={{visibility: (location.pathname !== '/contact-us') ? 'visible' : 'hidden'}}
            >
              <img src={require('../../assets/mail-icon.png')} />
              <p>Contact us</p>
            </div>
          </StyledHeader>
          
          
      }
      
    </React.Fragment>
  );
};

export default Header;
